import { ListingGalleryImage } from "components/ListingImageGallery/utils/types";

interface Amenity {
  name: string;
  icon: string;
}

// Define el tipo de cada hotel
interface Hotel {
  nombre: string;
  amenities: Amenity[];
}

export const Amenities_demos = [
  { name: "llave", icon: "la-key" },
  { name: "área para fumadores", icon: "la-smoking" },
  { name: "aire acondicionado", icon: "la-snowflake" },
  { name: "spa", icon: "la-spa" },
  { name: "la-suitcase-rolling", icon: "la-suitcase-rolling" },
  { name: "piscina exterior", icon: "la-swimmer" },
  { name: "piscina interior", icon: "la-swimming-pool" },
  { name: "televisor", icon: "la-tv" },
  { name: "restaurante", icon: "la-utensils" },
  { name: "accesos especiales", icon: "la-wheelchair" },
  { name: "wifi", icon: "la-wifi" },
  { name: "guarderia", icon: "la-baby-carriage" },
  { name: "baño privado", icon: "la-bath" },
  { name: "habitacion privada", icon: "la-bed" },
  { name: "la-briefcase", icon: "la-briefcase" },
  { name: "servicio de transporte", icon: "la-car" },
  { name: "Bar", icon: "la-cocktail" },
  { name: "Cafetería", icon: "la-coffee" },
  { name: "servicio a la habitacion", icon: "la-concierge-bell" },
  { name: "casino", icon: "la-dice" },
  { name: "gimnasio", icon: "la-dumbbell" },
  { name: "mucho más", icon: "la-infinity" },
];

export const amenities_hoteles : Hotel[] = [
  {
    nombre: "HEZE",
    amenities: [
      { name: "restaurante", icon: "la-utensils" },
      { name: "jacuzzi", icon: "la-bath" },
      { name: "sala de juegos", icon: "la-dice" },
      { name: "gym", icon: "la-dumbbell" },
    ]
  },
  {
    nombre: "SCLM",
    amenities: [
      { name: "llave", icon: "la-key" },
      { name: "baño privado", icon: "la-bath" },
      { name: "habitacion privada", icon: "la-bed" },
      { name: "wifi", icon: "la-wifi" },
      { name: "televisor", icon: "la-tv" },
      { name: "accesos especiales", icon: "la-wheelchair" }
    ]
  },
  {
    nombre: "HJDP",
    amenities: [
      { name: "llave", icon: "la-key" },
      { name: "baño privado", icon: "la-bath" },
      { name: "habitacion privada", icon: "la-bed" },
      { name: "televisor", icon: "la-tv" },
      { name: "wifi", icon: "la-wifi" },
      { name: "aire acondicionado", icon: "la-snowflake" }
    ]
  },
  {
    nombre: "VGBN",
    amenities: [
      { name: "llave", icon: "la-key" },
      { name: "baño privado", icon: "la-bath" },
      { name: "televisor", icon: "la-tv" },
      { name: "wifi", icon: "la-wifi" },
      { name: "aire acondicionado", icon: "la-snowflake" },
      { name: "habitacion privada", icon: "la-bed" }
    ]
  },
  {
    nombre: "HBRK",
    amenities: [
      { name: "llave", icon: "la-key" },
      { name: "baño privado", icon: "la-bath" },
      { name: "televisor", icon: "la-tv" },
      { name: "wifi", icon: "la-wifi" },
      { name: "aire acondicionado", icon: "la-snowflake" },
      { name: "habitacion privada", icon: "la-bed" },
      { name: "servicio de transporte", icon: "la-car" }
    ]
  },
  {
    nombre: "Default",
    amenities: [
      { name: "llave", icon: "la-key" },
      { name: "área para fumadores", icon: "la-smoking" },
      { name: "aire acondicionado", icon: "la-snowflake" },
      { name: "spa", icon: "la-spa" },
      { name: "la-suitcase-rolling", icon: "la-suitcase-rolling" },
      { name: "piscina exterior", icon: "la-swimmer" },
      { name: "piscina interior", icon: "la-swimming-pool" },
      { name: "televisor", icon: "la-tv" },
      { name: "restaurante", icon: "la-utensils" },
      { name: "accesos especiales", icon: "la-wheelchair" },
      { name: "wifi", icon: "la-wifi" },
      { name: "guarderia", icon: "la-baby-carriage" },
      { name: "baño privado", icon: "la-bath" },
      { name: "habitacion privada", icon: "la-bed" },
      { name: "la-briefcase", icon: "la-briefcase" },
      { name: "servicio de transporte", icon: "la-car" },
      { name: "Bar", icon: "la-cocktail" },
      { name: "Cafetería", icon: "la-coffee" },
      { name: "servicio a la habitacion", icon: "la-concierge-bell" },
      { name: "casino", icon: "la-dice" },
      { name: "gimnasio", icon: "la-dumbbell" },
      { name: "mucho más", icon: "la-infinity" }
    ]
  }
];

export const listingStayImageGallery = (photos: string[]): ListingGalleryImage[] => {
  return photos.map(
    (item, index): ListingGalleryImage => {
      return {
        id: index,
        url: item,
      };
    }
  );
};
